import getData from './Model';
import CardViewer from './CardViewer';
import styles from './ListViewer.module.css'
import { UseDocumentTitle } from './UseDocumentTitle'
import { useLanguage } from '../contexts/LanguageContext'

// Отображает список карточек с объектами типа entity
function ListViewer({entity}){
    const { language } = useLanguage()  // Get current language from context
    
    let data = getData(entity, language)  // Pass language to getData
    
    // Set document title based on language
    const ui = getData('ui', language)  // Get UI translations
    
    if (entity === 'projects') {
        const title = language === 'eng' ? 'Projects' : 'Проекты'
        UseDocumentTitle(title)
    }
    
    if (entity === 'pages') {
        const title = language === 'eng' ? 'Pages' : 'Страницы'
        UseDocumentTitle(title)
    }
        
    return ( 
        <div className={styles.ListViewer}>
            {
                data.map((item) => (
                    <CardViewer 
                        entity={entity} 
                        key={item.ob_id} 
                        {...item}
                        language={language}  // Pass language to CardViewer
                    />
                ))
            }
        </div> 
    )
}

export default ListViewer